import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ShoppingCartState } from '../../actions/standalone';
import { selectProductsList } from '../../actions/selector';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'productInShop',
    standalone: false
})
export class ProductInShopPipe implements PipeTransform {
  constructor(private store: Store<{ shoppingCart: ShoppingCartState }>) {}

  transform(productId: string) {
    return this.store.pipe(
      select(selectProductsList),
      map((value) => value.find((product) => product.productId === productId))
    );
  }
}
